<template>
    <v-container
        :fluid="!loading"
        :grid-list-lg="!loading"
        :fill-height="loading"
        :class="loading ? 'container-loading' : ''"
    >
        <v-layout
            wrap
            v-if="!loading"
        >
            <v-flex
                xs12
            >
                <custom-table
                    ref="customTable"

                    data-url="/quotations/index"
                    :single-item-name="'quotation'"
                    :plural-item-name="'quotations'"

                    :headers="headers"
                    :freeze="updating"
                    :breakpoint="950"

                    clickable
                    @click="view"
                >
                    <template
                        slot="row"
                        slot-scope="props"
                    >
<!--                        <td>-->
<!--                            {{ props.item.name }}-->
<!--                        </td>-->
                        <td>
                            <template
                                v-if="checkNested(props.item, 'client', 'name')"
                            >
                                {{ props.item.client.name }}
                            </template>
                        </td>
                        <td
                            class="text-center d-flex justify-center"
                        >
                            <div>
                                {{ props.item.reference_number }} <br>
                                <v-chip
                                    :color="getChipColor(props.item)"
                                    dark
                                    small
                                >
                                    {{ getChipContent(props.item) }}
                                </v-chip>
                            </div>
                            <v-tooltip
                                bottom
                                v-if="props.item.holders.length"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        class="ml-2"
                                    >
                                        $mdiAccountStar
                                    </v-icon>
                                </template>
                                <span>
                                    Associated to a Policy Holder
                                </span>
                            </v-tooltip>

                            <v-tooltip
                                bottom
                                v-if="props.item.leads.length"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        class="ml-2"
                                    >
                                        $mdiBriefcaseAccount
                                    </v-icon>
                                </template>
                                <span>
                                    Associated to a Lead
                                </span>
                            </v-tooltip>

                            <v-tooltip
                                bottom
                                v-if="props.item.fo_id"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        class="ml-2"
                                    >
                                        $mdiAccountEdit
                                    </v-icon>
                                </template>
                                <span>
                                    Created by a Fulfilment Officer
                                </span>
                            </v-tooltip>
                        </td>
                        <td
                            class="text-center"
                        >
                            <v-tooltip
                                bottom
                                v-if="checkNested(props.item, 'total_premium') && checkNested(props.item, 'monthly_payment')"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                        v-on="on"
                                    >
                                        {{ props.item.total_premium | currency }}
                                    </span>
                                </template>
                                <span>
                                    Total Monthly Payment: {{ props.item.monthly_payment | currency }}
                                </span>
                            </v-tooltip>
                        </td>
<!--                        <td-->
<!--                            class="text-center"-->
<!--                        >-->
<!--                            {{ props.item.version }}-->
<!--                        </td>-->
<!--                        <td-->
<!--                            class="text-center"-->
<!--                        >-->
<!--                            <template-->
<!--                                v-if="checkNested(props.item, 'selected_lpp_label')"-->
<!--                            >-->
<!--                                {{ props.item.selected_lpp_label }}-->
<!--                            </template>-->
<!--                        </td>-->
<!--                        <td-->
<!--                            class="text-center"-->
<!--                        >-->
<!--                            Created at: {{ props.item.created_at|date }} <br> {{ props.item.created_at|fromNow }}-->
<!--                        </td>-->
                    </template>



                    <template
                        slot="card"
                        slot-scope="props"
                    >
                        <td
                            class="v-data-table__mobile-row"
                        >
                            <div
                                class="text-center w-full"
                            >
                                <v-chip
                                    :color="getChipColor(props.item)"
                                    dark
                                    small
                                >
                                    {{ getChipContent(props.item) }}
                                </v-chip>
                            </div>
                        </td>
                        <td
                            class="v-data-table__mobile-row"
                            v-for="(header, headerIndex) in headers"
                            :key="headerIndex"
                        >
                            <div class="v-data-table__mobile-row__header">
                                {{ header.text }}
                            </div>
                            <div class="v-data-table__mobile-row__cell">
                                <template
                                    v-if="header.value === 'client_name'"
                                >
                                    <template
                                        v-if="checkNested(props.item, 'client', 'name')"
                                    >
                                        {{ props.item.client.name }}
                                    </template>
                                </template>
                                <template
                                    v-else-if="header.value === 'reference_number'"
                                >
                                    {{ props.item.reference_number }} <br>

                                    <v-tooltip
                                        bottom
                                        v-if="props.item.holders.length"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                $mdiAccountStar
                                            </v-icon>
                                        </template>
                                        <span>
                                            Associated to a Policy Holder
                                        </span>
                                    </v-tooltip>

                                    <v-tooltip
                                        bottom
                                        v-if="props.item.leads.length"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                $mdiBriefcaseAccount
                                            </v-icon>
                                        </template>
                                        <span>
                                            Associated to a Lead
                                        </span>
                                    </v-tooltip>

                                    <v-tooltip
                                        bottom
                                        v-if="props.item.fo_id"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                $mdiAccountEdit
                                            </v-icon>
                                        </template>
                                        <span>
                                            Created by a Fulfilment Officer
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template
                                    v-else-if="header.value === 'premium'"
                                >
                                    <template
                                        v-if="checkNested(props.item, 'total_premium')"
                                    >
                                        {{ props.item.total_premium | currency }} <br>
                                    </template>
                                </template>
                                <template
                                    v-else
                                >
                                    {{ $refs.customTable.getCardValue(props.item, header.value) }}
                                </template>
                            </div>
                        </td>
                    </template>
                </custom-table>
            </v-flex>
        </v-layout>
        <v-layout
            v-else
            justify-center
            align-center
            column
        >
            <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-layout>
    </v-container>
</template>
<script>
    import IconCard from './Components/IconCard';

    export default {
        components: {
            IconCard,
        },

        data() {
            return {
                loading: true,
                fetching: true,

                updating: false,

                stats: {},
            }
        },
        name: 'Quotations-Index',
        mounted() {
            this.$store.dispatch('resources/getResource', 'quotationTypes')
                .then(response => {
                    this.types = response;
                    this.typesLoaded = true;

                    this.$store.dispatch('table/addToFilters', {type: 'type', data: response});
                });

            // this.getStats();
            this.loading = false;
            this.fetching = false;
        },
        computed: {
            headers() {
                let headers = [
                    // {text: 'Name', value: 'name', align: 'left', sortable: false},
                    {text: 'Client name', value: 'client_name', align: 'left', sortable: false},
                    {text: 'Reference', value: 'reference_number', align: 'center', sortable: false},
                    {text: 'Premium', value: 'premium', align: 'center', sortable: false},
                    // {text: 'Version', value: 'version', align: 'center', sortable: false},
                    // {text: 'Selected LPP™ ', value: 'selected_lpp_label', align: 'center', sortable: false},
                    // {text: 'Created', value: 'created_at', align: 'center', sortable: false},
                ];

                return headers;
            }
        },

        methods: {
            view(item) {
                this.$router.push('/quotations/view/' + item.id + '?tab=info');
            },

            getStats() {
                this.fetching = true;

                window.axios.post('/quotations/getStats')
                    .then((response) => {
                        this.stats = response.data.stats;

                        this.loading = false;
                        this.fetching = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        this.loading = false;
                        this.fetching = false;
                    })

            },

            getChipColor(item) {
                if (item.type === 1) {
                    return 'purple';
                }

                if (item.type === 2) {
                    return 'accent';
                }

                return 'pink darken-4';
            },
            getChipContent(item) {
                if (item.type === 1) {
                    return 'MyCover™';
                }

                if (item.type === 2) {
                    return 'HomeVantage™';
                }

                return 'KeyPlan™';
            }
        },
    }
</script>
